const OverflowingStyle = { textOverflow: 'ellipsis', whiteSpace: 'break-spaces' };

export default function contactAndAdditionalInformationColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId;

        config.columns.forEach(column => {
            const columnId = column.id;
            let displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let isDisabled = false;
            if (columnDataType === "string") {
                if (columnId === "customerInformation") {
                    columnValue = (<>
                        {
                            order.isRetrievedCTquotes ?
                                <div style={OverflowingStyle}><b>Company Name: </b>{order.company}</div> :
                                <div style={OverflowingStyle}><b>Full Name: </b>{order.firstName + " " + order.lastName}</div>
                        }
                        <div style={OverflowingStyle}><b>Email: </b>{order.email}</div>
                        <div style={OverflowingStyle}><b>Tel: </b>{order.contactNo}</div>
                    </>);
                }
                if (columnId === "contactInformation") {
                    if (order.isRetrievedCTquotes) {
                        columnValue = (<>
                            <div style={OverflowingStyle}><b>Company Name: </b>{order.company}</div>
                            <div style={OverflowingStyle}><b>Email: </b>{order.email}</div>
                            <div style={OverflowingStyle}><b>Tel: </b>{order.contactNo}</div>
                        </>)
                    } else {
                        columnValue = (order.alternateFirstName && order.alternateLastName && order.alternateEmail && order.alternatePhone) ? (<>
                            <div style={OverflowingStyle}><b>Full Name: </b>{order.alternateFirstName + " " + order.alternateLastName}</div>
                            <div style={OverflowingStyle}><b>Email: </b>{order.alternateEmail}</div>
                            <div style={OverflowingStyle}><b>Tel: </b>{order.alternatePhone}</div>
                        </>) : (<>
                            <div style={OverflowingStyle}><b>Full Name: </b>{order.firstName + " " + order.lastName}</div>
                            <div style={OverflowingStyle}><b>Email: </b>{order.email}</div>
                            <div style={OverflowingStyle}><b>Tel: </b>{order.contactNo}</div>
                        </>);
                    }

                }
                if (columnId === "additionalComments") {
                    columnValue = order.additionalComments || "";
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}